import { createFormItem } from "@/component-create/utils/create-form-item";
import { FORM_ITEM } from "@/components/form/enums";

export const searchFormItems = [
  createFormItem('操作状态', 'resultType', FORM_ITEM.SELECT, { loader: 'LOG_RESULT_TYPE'}),
  createFormItem('起止时日', 'timeRange', FORM_ITEM.DATE_PICKER_CUSTOM, { valueFormat: "YYYY-MM-DD HH:mm:ss", type:"datetimerange" }),
  createFormItem('操作模块', 'module', FORM_ITEM.INPUT),
  createFormItem('操作描述', 'message', FORM_ITEM.INPUT),
  createFormItem('请求参数', 'reqParam', FORM_ITEM.INPUT),
  createFormItem('响应结果', 'resParam', FORM_ITEM.INPUT),
  createFormItem('操作用户', 'username', FORM_ITEM.INPUT),
  createFormItem('请求地址', 'reqUrl', FORM_ITEM.INPUT),
]
